import { render, staticRenderFns } from "./SaplingScreenCapturePreview.vue?vue&type=template&id=4261ef65&scoped=true"
import script from "./SaplingScreenCapturePreview.vue?vue&type=script&lang=ts"
export * from "./SaplingScreenCapturePreview.vue?vue&type=script&lang=ts"
import style0 from "./SaplingScreenCapturePreview.vue?vue&type=style&index=0&id=4261ef65&prod&scoped=true&lang=scss"
import style1 from "./SaplingScreenCapturePreview.vue?vue&type=style&index=1&id=4261ef65&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4261ef65",
  null
  
)

export default component.exports